import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

type MissingDataHeaderData = {
  missingSourceFreshness?: boolean;
  setMissingSourceFreshness: (missingTestResults: boolean) => void;
  missingTestResults?: boolean;
  setMissingTestResults: (missingTestResults: boolean) => void;
  missingCatalogInfo?: boolean;
  setMissingCatalogInfo: (missingTestResults: boolean) => void;
};

const MissingDataHeaderContext = createContext<MissingDataHeaderData>({
  missingSourceFreshness: false,
  setMissingSourceFreshness: () => undefined,
  missingTestResults: false,
  setMissingTestResults: () => undefined,
  missingCatalogInfo: false,
  setMissingCatalogInfo: () => undefined,
});

export const useMissingDataHeader = () => {
  return useContext(MissingDataHeaderContext);
};

export type MissingDataHeaderParams = {
  missingSourceFreshness?: boolean;
  missingTestResults?: boolean;
  missingCatalogInfo?: boolean;
};

export const MissingDataHeaderProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [missingSourceFreshness, setMissingSourceFreshness] = useState<boolean>(false);
  const [missingTestResults, setMissingTestResults] = useState<boolean>(false);
  const [missingCatalogInfo, setMissingCatalogInfo] = useState<boolean>(false);
  return (
    <MissingDataHeaderContext.Provider
      value={{
        missingSourceFreshness,
        setMissingSourceFreshness,
        missingTestResults,
        setMissingTestResults,
        missingCatalogInfo,
        setMissingCatalogInfo,
      }}
    >
      {children}
    </MissingDataHeaderContext.Provider>
  );
};
